import Typewriter from "../ui/Typewriter";

const MODAL_STYLES = `
  .mission-modal-scroll::-webkit-scrollbar {
    width: 4px;
  }
  .mission-modal-scroll::-webkit-scrollbar-track {
    background: rgba(255,255,255,.04);
    border-radius: 4px;
  }
  .mission-modal-scroll::-webkit-scrollbar-thumb {
    background: rgba(99,102,241,.4);
    border-radius: 4px;
  }
  .mission-modal-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(99,102,241,.7);
  }
  .mission-modal-scroll-log::-webkit-scrollbar-thumb {
    background: rgba(52,211,153,.4);
  }
  .mission-modal-scroll-log::-webkit-scrollbar-thumb:hover {
    background: rgba(52,211,153,.7);
  }
`;

export default function MissionModal({ open, onClose, title = "Brief de mission", body, variant = "default" }) {
  if (!open) return null;

  const isLog = variant === "log";
  const accentColor = isLog ? "rgba(52,211,153," : "rgba(99,102,241,";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <style>{MODAL_STYLES}</style>

      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" onClick={onClose} />

      {/* Panel */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          width: "100%",
          maxWidth: "42rem",
          background: "#04050f",
          border: "1px solid rgba(255,255,255,.08)",
          borderRadius: 14,
          boxShadow: `0 0 60px rgba(0,0,0,.8), 0 0 0 1px ${accentColor}0.08)`,
          fontFamily: "ui-monospace,'SF Mono',Menlo,monospace",
          overflow: "hidden",
        }}
      >
        {/* Coins déco */}
        <div style={{ position: "absolute", top: 0, left: 0, width: 18, height: 18, borderTop: `1px solid ${accentColor}0.5)`, borderLeft: `1px solid ${accentColor}0.5)`, pointerEvents: "none", zIndex: 5 }} />
        <div style={{ position: "absolute", bottom: 0, right: 0, width: 18, height: 18, borderBottom: `1px solid ${accentColor}0.5)`, borderRight: `1px solid ${accentColor}0.5)`, pointerEvents: "none", zIndex: 5 }} />

        {/* Header */}
        <div style={{ padding: "14px 18px 12px", borderBottom: "1px solid rgba(255,255,255,.05)", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
          <div>
            <div style={{ fontSize: 9, letterSpacing: ".24em", textTransform: "uppercase", color: `${accentColor}0.6)`, marginBottom: 5, fontWeight: 700 }}>
              ◈ {isLog ? "Notes de mission" : "Brief de mission"}
            </div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "rgba(241,245,249,.97)", fontFamily: "ui-sans-serif,system-ui", letterSpacing: "-.01em", lineHeight: 1.2 }}>
              {title}
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Fermer"
            style={{ width: 28, height: 28, borderRadius: 6, border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.04)", color: "rgba(148,163,184,.7)", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
          >
            ✕
          </button>
        </div>

        {/* Corps */}
        <div style={{ padding: "14px 18px" }}>
          <div
            className={`mission-modal-scroll${isLog ? " mission-modal-scroll-log" : ""}`}
            style={{
              background: isLog ? "rgba(2,12,8,.9)" : "rgba(0,0,0,.35)",
              border: `1px solid ${accentColor}0.2)`,
              borderRadius: 9,
              padding: "14px 16px",
              fontFamily: "ui-monospace,'SF Mono',Menlo,monospace",
              fontSize: 13,
              color: isLog ? "rgba(52,211,153,.9)" : "rgba(203,213,225,.85)",
              overflowY: "auto",
              maxHeight: "55vh",
              lineHeight: 1.7,
              letterSpacing: ".01em",
            }}
          >
            <Typewriter text={body} />
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "0 18px 14px", display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              padding: "9px 22px",
              borderRadius: 7,
              cursor: "pointer",
              border: `1px solid ${accentColor}0.45)`,
              background: isLog
                ? "repeating-linear-gradient(45deg,rgba(52,211,153,.04) 0,rgba(52,211,153,.04) 1px,transparent 1px,transparent 7px),rgba(52,211,153,.12)"
                : "repeating-linear-gradient(45deg,rgba(99,102,241,.04) 0,rgba(99,102,241,.04) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.14)",
              color: isLog ? "rgba(110,231,183,.95)" : "rgba(165,180,252,.95)",
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: ".08em",
              textTransform: "uppercase",
              clipPath: "polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",
              boxShadow: isLog ? "0 0 14px rgba(52,211,153,.1)" : "0 0 14px rgba(99,102,241,.12)",
              transition: "all .15s",
            }}
          >
            J'ai lu, on y va
          </button>
        </div>
      </div>
    </div>
  );
}